export const isEmpty = (val) => {
  return !Object.getOwnPropertyNames(val).length
}
